import { Modal } from 'antd';

import React, { useState } from 'react';

import CardLimitData from '@portal/components/CardLimitData/CardLimitData';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { translate } from '@portal/services/i18n';

interface CardUpdateModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onSubmit: (newValue: number) => void;
  card: bank.Card | null;
}

const CardLimitUpdateModal = ({
  setVisible,
  onSubmit,
  visible,
  card,
}: CardUpdateModalProps) => {
  const [cardLimit, setCardLimit] = useState(card?.limitAvailable ?? null);

  if (!card) {
    return null;
  }

  const handleCancel = () => {
    setCardLimit(card?.limitAvailable ?? null);
    setVisible(false);
  };

  const handleSubmit = () => {
    if (!cardLimit) {
      return;
    }

    onSubmit(cardLimit);
  };

  return (
    <Modal
      open={visible}
      footer={
        <AdvancedButton
          text={translate('PAGES.CARDS.LIMIT_MODAL.UPDATE')}
          onClick={handleSubmit}
        />
      }
      onCancel={handleCancel}
    >
      <CardLimitData
        setCardLimit={setCardLimit}
        cardLimit={cardLimit}
        card={card}
      />
    </Modal>
  );
};

export default CardLimitUpdateModal;
